module.exports = __webpack_public_path__ + "static/images/styles/core/components/button/images/default-bg.519d1247.png";


//////////////////
// WEBPACK FOOTER
// ./styles/core/components/button/images/default-bg.png
// module id = 3486
// module chunks = 11